import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';

type FieldsetLegendProps = {
  label?: string;
  description?: ReactNode;
  variant?: 'default' | 'large';
  required?: boolean;
  className?: string;
};

export const FieldsetLegend = ({
  label,
  description,
  variant = 'default',
  required,
  className,
}: FieldsetLegendProps) => {
  if (!label && !description) {
    return null;
  }

  const isLarge = variant === 'large';
  const legendClassName = isLarge ? 'text-base font-semibold text-gray-900' : 'text-sm text-gray-500';

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <legend className={cn('block text-wrap', legendClassName)}>
          {label}
          {Boolean(required) && <span className="text-procuros-green-600"> *</span>}
        </legend>
      )}
      {description && <p className="text-sm text-gray-700">{description}</p>}
    </div>
  );
};
